var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVolumeUp = function SvgVolumeUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    fill: "none",
    viewBox: "0 0 92 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    x: 7.931,
    y: 2,
    stroke: "#F7F4F2",
    strokeWidth: 2.591,
    rx: 38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F4F2",
    fillRule: "evenodd",
    d: "M49.13 32.212a1.457 1.457 0 0 1 2.04-.292 9.265 9.265 0 0 1 0 14.825 1.457 1.457 0 1 1-1.749-2.332 6.35 6.35 0 0 0 0-10.16 1.457 1.457 0 0 1-.291-2.041Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F4F2",
    fillRule: "evenodd",
    d: "M53.379 27.483a1.457 1.457 0 0 1 2.05-.218 15.512 15.512 0 0 1 0 24.13 1.457 1.457 0 0 1-1.833-2.268 12.597 12.597 0 0 0 0-19.595 1.457 1.457 0 0 1-.217-2.05ZM42.592 28.856l-5.2 6.685c-.276.356-.7.563-1.15.563h-3.124a.104.104 0 0 0-.104.104v6.247c0 .057.047.104.104.104h3.108l.082.001a1.45 1.45 0 0 1 1.093.573l5.19 6.674V28.856Zm-7.063 16.618h-2.41a3.02 3.02 0 0 1-3.02-3.02v-6.246a3.02 3.02 0 0 1 3.02-3.019h2.41l4.96-6.377a2.707 2.707 0 0 1 5.018 1.688v21.663a2.707 2.707 0 0 1-5.018 1.688l-4.96-6.377Z",
    clipRule: "evenodd"
  })));
};
export default SvgVolumeUp;